import { toast } from "react-toastify"
import { HTTP as Connection } from "./Connection"

// Wraps HTTP so that a request the server never responds to (network failure or
// timeout, tagged with networkError by Connection.js) surfaces a toast, while still
// rejecting so callers keep their existing error handling.
function withNetworkErrorToast(promise) {
  return promise.catch((error) => {
    if (error && error.networkError) {
      toast(error.message, { className: "bg-danger text-white" })
    }
    throw error
  })
}

export const HTTP = {
  get: (url) => withNetworkErrorToast(Connection.get(url)),
  post: (url, message) => withNetworkErrorToast(Connection.post(url, message)),
  put: (url, message) => withNetworkErrorToast(Connection.put(url, message)),
  delete: (url, message) => withNetworkErrorToast(Connection.delete(url, message))
}
